// extracted by mini-css-extract-plugin
module.exports = {"root":"MdxWrapper-module--root--2oOqS","lead":"MdxWrapper-module--lead--2tH_0"};